import styled from "styled-components";

export const LogoImg = styled.img`
  display: block;
  width: 227px;
  height: auto;
`;
